import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

// Queries
import postGlobal from '../Queries/postGlobal';

// Styles
import styles from './index.module.sass';
import { styled } from '@mui/material/styles';

const date = new Date();

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#002747',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 100,
    backgroundColor: '#002747',
  },
});

export default function MiniCartItem({
  item,
  getCookie,
  webservice,
  setOrderData,
  setSessionMessage,
  setHaveMessage,
}) {
  const {
    agrupador = '',
    imagen = '',
    descri = '',
    clave = '',
    letra = '',
    cantidad = '',
    precio = '',
    importe = '',
    numeroLinea = '',
    categoria = '',
    status = '',
  } = item;

  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation('minicart');

  function Totals({ totalName, totalText }) {
    return (
      <div className={styles.total}>
        <div>{totalName}</div>
        <div>{totalText}</div>
      </div>
    );
  }

  async function changeOrder(action, cat, id, quantity, lineNum) {
    setLoading(true);
    const order = await postGlobal({
      tmbservice: 'getAgregarAlCarrito',
      jsonBody: {
        accion: action,
        usuarioOK: getCookie('usuarioOk'),
        folioPedido: getCookie('folioPedido'),
        almacen: getCookie('warehouse'),
        categoria: cat,
        clave: id,
        cantidad: quantity,
        numeroLinea: lineNum,
        textoProdSeleccion: '',
        idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
        origen: 'CARRITONUE',
      },
    });

    const { tipoMensaje = 'error', mensaje = '' } = order;
    if (tipoMensaje === 'exito') {
      setOrderData(order || {});
    }

    setLoading(false);
    setSessionMessage(mensaje);
  }

  function handleChange(e) {
    const value = e.target.value;
    setQuantity(value);
  }

  useEffect(() => {
    if (status) {
      setHaveMessage((oldArray) => [...oldArray, clave]);
    }
  }, [status, setHaveMessage, clave]);

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <img src={`${imagen}?x=${date.getFullYear()}${date.getMonth() + 1}`} alt={descri} />
      </div>
      <div className={styles.data}>
        <div className={styles.itemName}>
          <span className={styles.id}>{clave} - </span>
          <span className={styles.name}>{descri}</span>
          {agrupador === 'COMPONENTES' && (
            <span className={styles.name}> ({t('isComponent')})</span>
          )}
          {agrupador === 'REGALOS' && <span className={styles.name}> ({t('isGift')})</span>}
          {agrupador === 'TAX' && <span className={styles.name}> ({t('isTax')})</span>}
        </div>
        <div className={styles.totals}>
          <Totals totalName={t('units')} totalText={cantidad} />
          <Totals totalName={t('letter')} totalText={letra} />
          <Totals totalName={t('price')} totalText={precio} />
          <Totals totalName={t('amount')} totalText={importe} />
        </div>
        {agrupador !== 'COMPONENTES' && agrupador !== 'REGALOS' && agrupador !== 'TAX' && (
          <div className={styles.actions}>
            {(status === 'Producto Agotado.' && (
              <div className={styles.outOfStock}>{t('defaultSoldOut')}</div>
            )) || (
              <div className={styles.moreless}>
                {(loading && (
                  <div className={styles.loading}>
                    <CircularProgress className={styles.circular} />
                  </div>
                )) || (
                  <>
                    <div className={`${styles.action}`}>
                      {parseInt(cantidad) > 1 && (
                        <i
                          className={`material-icons-outlined ${styles.actionIcon}`}
                          onClick={() =>
                            changeOrder(
                              'ORDENAR',
                              categoria,
                              clave,
                              parseInt(cantidad) - parseInt(quantity),
                              numeroLinea,
                            )
                          }>
                          remove
                        </i>
                      )}
                    </div>
                    <div className={`${styles.action}`}>
                      <input
                        type='text'
                        className={styles.quantityInput}
                        value={quantity}
                        onChange={handleChange}
                      />
                    </div>
                    <div className={`${styles.action}`}>
                      <i
                        className={`material-icons-outlined ${styles.actionIcon}`}
                        onClick={() =>
                          changeOrder(
                            'ORDENAR',
                            categoria,
                            clave,
                            parseInt(cantidad) + parseInt(quantity),
                            numeroLinea,
                          )
                        }>
                        add
                      </i>
                    </div>
                  </>
                )}
              </div>
            )}
            {status !== '' && (
              <div className={`${styles.column}`}>
                <div className={styles.alert}>
                  <CustomWidthTooltip title={status} placement='right' arrow>
                    {
                      <span className={`material-icons-outlined ${styles.tooltip}`}>
                        report_problem
                      </span>
                    }
                  </CustomWidthTooltip>
                </div>
              </div>
            )}
            <div className={styles.delete}>
              <div className={styles.deleteIcon}>
                <i
                  className={`material-icons-outlined ${styles.dicon}`}
                  onClick={() => {
                    if (loading) return null;
                    changeOrder('BORRARPRO', categoria, clave, parseInt(cantidad), numeroLinea);
                  }}>
                  delete
                </i>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
